// extracted by mini-css-extract-plugin
module.exports = {"Anchor":"Anchor_Anchor__J8jHP"};